import { forwardRef } from "react"

import style from "modules/PsyProfile/components/WhyAlter/style.module.scss"
import { CHECKS } from "modules/PsyProfile/components/WhyAlter/constants"
import { Icon } from "components"
import { PERCENT_OF_SELECTED_PSYCHOLOGISTS } from "utils/env-management"
import { Text } from "ui-kit/components-branded/Text"

export const WhyAlter = forwardRef<HTMLDivElement>((_, ref) => (
    <section className={style.container} ref={ref}>
        <div className={style.content}>
            <h2 className={style.title} data-testid="psy-profile-why-title">
                Почему стоит записаться через Alter
            </h2>
            <Text className={style.description}>
                Все наши психологи прошли отбор по&nbsp;методике, разработанной на&nbsp;базе
                ПИ&nbsp;РАО&nbsp;&mdash; старейшего в&nbsp;России научно-исследовательского
                психологического учреждения (1912г.). Только&nbsp;
                {PERCENT_OF_SELECTED_PSYCHOLOGISTS} психологов проходят отбор.
            </Text>
            <h2 className={style.title}>Мы проверяем</h2>
            <ul className={style.checks}>
                {CHECKS.map((text, index) => (
                    <li className={style.checksItem} key={index}>
                        <Icon
                            type="verify"
                            color="green-2"
                            size={14}
                            className={style.checksIcon}
                        />
                        <Text>{text}</Text>
                    </li>
                ))}
            </ul>
        </div>
    </section>
))

WhyAlter.displayName = "WhyAlter"
